import { localize } from '@saviynt/common';

import {
  EO_ROWS_CONSTANT_MAP,
  ROWS_CONSTANT_MAP,
} from '../../../components/ViewControls/RowsFilter/constant';
import { getMessageKey } from '../../../utils/utils';

export const formatFilters = (filters) => {
  // Create an empty object to group by keys
  const groupedFilters = {};

  // Iterate over each filter
  filters?.forEach((filter) => {
    const { key, label } = filter;

    // If the key doesn't exist in the groupedFilters object, add it
    if (!groupedFilters[key]) {
      groupedFilters[key] = [];
    }

    // Push the label for this key into the array (avoid duplicates)
    if (!groupedFilters[key].includes(label)) {
      groupedFilters[key].push(label);
    }
  });

  // Format the output as a string
  return Object.keys(groupedFilters)
    .map((key) => `${key}: ${groupedFilters[key].join(', ')}`)
    .join(', ');
};

export const formatRows = (isEOCampaign, rows) => {
  const rowsName = rows?.map((item) => {
    if (isEOCampaign) return EO_ROWS_CONSTANT_MAP[item];

    return ROWS_CONSTANT_MAP[item];
  });

  return `ROWS: ${rowsName?.join(', ')}`;
};

export const MANDATORY_COLUMNS = [
  'User_DISPLAYNAME',
  'Role_DISPLAYNAME',
  'Account_DISPLAYNAME',
  'Ent_DISPLAYNAME',
  'Ent2_DISPLAYNAME',
  'Ent2_DISPLAYNAME.ATTESTATIONS',
];

export const EO_MANDATORY_COLUMNS = [
  'DEFAULTENTITLEMENTNAME',
  'DEFAULTACCOUNTNAME',
  'DEFAULTENTITLEMENT2NAME',
  'Account_DISPLAYNAME',
  'Ent_DISPLAYNAME',
  'ChildEnt_DISPLAYNAME',
  'Ent2_DISPLAYNAME',
];

const MANDATORY_COLUMNS_MSG_KEY = {
  'User_DISPLAYNAME.ATTESTATIONS': 'User_DISPLAYNAME.CERTIFICATIONS',
  'Account_DISPLAYNAME.ATTESTATIONS': 'Account_DISPLAYNAME.CERTIFICATIONS',
  'Role_DISPLAYNAME.ATTESTATIONS': 'Role_DISPLAYNAME.CERTIFICATIONS',
  'Ent_DISPLAYNAME.ATTESTATIONS': 'Ent_DISPLAYNAME.CERTIFICATIONS',
  'ChildEnt_DISPLAYNAME.ATTESTATIONS': 'ChildEnt_DISPLAYNAME.CERTIFICATIONS',
  'Ent2_DISPLAYNAME.ATTESTATIONS': 'Ent2_DISPLAYNAME.ATTESTATIONS',
  'DEFAULTENTITLEMENTNAME.ATTESTATIONS': 'Ent_DISPLAYNAME.CERTIFICATIONS',
  'DEFAULTACCOUNTNAME.ATTESTATIONS': 'Account_DISPLAYNAME.CERTIFICATIONS',
  'DEFAULTENTITLEMENT2NAME.ATTESTATIONS': 'ChildEnt_DISPLAYNAME.CERTIFICATIONS',
};

// Helper function to get label for a column
export const getColumnLabel = (column, messagesArray, internationalization) =>
  messagesArray[MANDATORY_COLUMNS_MSG_KEY[column]] ||
  messagesArray[column] ||
  localize(internationalization, getMessageKey(column?.split('.')[0]));

const COLUMN_KEY_MAP = {
  User: ['User_DISPLAYNAME'],
  Role: ['Role_DISPLAYNAME'],
  Account: ['Account_DISPLAYNAME'],
  Entitlement: ['Ent_DISPLAYNAME'],
};

const EO_COLUMN_KEY_MAP = {
  Account: ['DEFAULTACCOUNTNAME'],
  Entitlement: ['DEFAULTENTITLEMENTNAME'],
  'Child Entitlement': ['DEFAULTENTITLEMENT2NAME'],
};

export const EO_DEFAULT_PROPERTIES = {
  Entitlement: {
    DEFAULTENTITLEMENTNAME: 'DEFAULTENTITLEMENTNAME.ATTESTATIONS',
  },
  Account: {
    DEFAULTACCOUNTNAME: 'DEFAULTACCOUNTNAME.ATTESTATIONS',
  },
  'Child Entitlement': {
    DEFAULTENTITLEMENT2NAME: 'DEFAULTENTITLEMENT2NAME.ATTESTATIONS',
  },
};

// Helper function to map columns to their label and status
export const mapColumnData = (
  isEOCampaign,
  columns,
  messagesArray,
  internationalization,
  key
) =>
  columns
    ?.map((item) => {
      const columnKey = item?.split('.')[0];

      return {
        id: item,
        label: getColumnLabel(item, messagesArray, internationalization),
        isChecked: true,
        isDisabled: isEOCampaign
          ? EO_COLUMN_KEY_MAP[key]?.includes(columnKey)
          : COLUMN_KEY_MAP[key]?.includes(columnKey),
      };
    })
    .sort((a, b) => b.isDisabled - a.isDisabled);
